import { useState } from "react"
import { doc, addDoc, updateDoc, getDoc, deleteDoc, collection } from "firebase/firestore"
import { db } from "../../services/firebase"
import { LABEL_S, INPUT_S, BTN_PRIMARY, BTN_GHOST, PROVINCIAS, AEROLINEAS, CANALES } from "../../utils/adminConstants"
import Modal from "./Modal"

const DESTINOS_VIAJE = [
  "Búzios","Río de Janeiro","Maceió","Maragogi","Arraial do Cabo",
  "Cabo Frío","Florianópolis","Punta Cana","Porto Galinhas",
  "Cancún","Cartagena","Bayahibe","Playa del Carmen","Panamá","Playa Blanca"
]

const OTRO = "__otro__"

const VIAJE_VACIO = { destino1:"", destino2:"", fecha_salida:"", fecha_regreso:"", noches:"", pax:"2", aerolinea:"", hotel1:"", hotel2:"", incluye:"", asistencia:"No", traslados:"", estado:"confirmado", canal_venta:"", referido_por:"", referido_id:"", origen:"", monto_venta:"", monto_reserva:"", hora_vuelo_salida:"", hora_vuelo_regreso:"" }

function BuscadorReferido({ clientes, clienteId, value, onSelect }) {
  const [busqueda, setBusqueda] = useState(value || "")
  const [abierto, setAbierto]   = useState(false)

  const filtrados = busqueda.length >= 2
    ? clientes.filter(c => c.id !== clienteId && `${c.nombre} ${c.apellido}`.toLowerCase().includes(busqueda.toLowerCase())).slice(0, 7)
    : []

  function seleccionar(c) {
    setBusqueda(`${c.nombre} ${c.apellido}`)
    onSelect(c)
    setAbierto(false)
  }

  return (
    <div style={{ position:"relative" }}>
      <input
        value={busqueda}
        onChange={e => { setBusqueda(e.target.value); setAbierto(true); if(!e.target.value) onSelect(null) }}
        onFocus={() => setAbierto(true)}
        onBlur={() => setTimeout(() => setAbierto(false), 180)}
        style={INPUT_S}
        placeholder="Escribí 2+ letras para buscar..."
        autoComplete="off"
      />
      {abierto && filtrados.length > 0 && (
        <div style={{ position:"absolute", top:"100%", left:0, right:0, zIndex:50, background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"8px", marginTop:"4px", maxHeight:"200px", overflowY:"auto", boxShadow:"0 8px 24px rgba(0,0,0,0.4)" }}>
          {filtrados.map(c => (
            <button key={c.id} onMouseDown={() => seleccionar(c)}
              style={{ display:"block", width:"100%", padding:"10px 14px", textAlign:"left", background:"none", border:"none", borderBottom:"1px solid #2a2a2a", color:"#e5e7eb", fontFamily:"Inter, sans-serif", fontSize:"0.85rem", cursor:"pointer" }}
              onMouseEnter={e => e.currentTarget.style.background="#2a2a2a"}
              onMouseLeave={e => e.currentTarget.style.background="none"}>
              <span style={{ fontWeight:600 }}>{c.nombre} {c.apellido}</span>
              <span style={{ fontSize:"0.75rem", color:"#6b7280", marginLeft:"8px" }}>{c.ciudad||""}</span>
            </button>
          ))}
        </div>
      )}
      {abierto && busqueda.length >= 2 && filtrados.length === 0 && (
        <div style={{ position:"absolute", top:"100%", left:0, right:0, zIndex:50, background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"8px", marginTop:"4px", padding:"12px 14px", color:"#4b5563", fontSize:"0.8rem" }}>
          Sin resultados
        </div>
      )}
    </div>
  )
}

export default function ModalViaje({ clienteId, clienteNombre, clienteOrigen, clienteCuil, clienteTelefono, clienteEmail, clientes, viajeInicial, onGuardado, onCerrar }) {
  const esNuevo = !viajeInicial

  const [form, setForm] = useState(() => {
    if (viajeInicial) {
      return {
        destino1:    viajeInicial.destino1    || viajeInicial.destino || "",
        destino2:    viajeInicial.destino2    || "",
        fecha_salida:viajeInicial.fecha_salida|| "",
        fecha_regreso:viajeInicial.fecha_regreso|| "",
        noches:      String(viajeInicial.noches || ""),
        pax:         String(viajeInicial.pax   || "2"),
        aerolinea:   viajeInicial.aerolinea   || "",
        hotel1:      viajeInicial.hotel1      || "",
        hotel2:      viajeInicial.hotel2      || "",
        incluye:     viajeInicial.incluye     || "",
        asistencia:  viajeInicial.asistencia  || "No",
        estado:      viajeInicial.estado      || "confirmado",
        canal_venta: viajeInicial.canal_venta || "",
        referido_por:viajeInicial.referido_por|| "",
        referido_id: viajeInicial.referido_id || "",
        origen:      viajeInicial.origen      || clienteOrigen || "",
        monto_venta:          String(viajeInicial.monto_venta    || ""),
        monto_reserva:        String(viajeInicial.monto_reserva  || ""),
        traslados:            viajeInicial.traslados              || "",
        hora_vuelo_salida:    viajeInicial.hora_vuelo_salida      || "",
        hora_vuelo_regreso:   viajeInicial.hora_vuelo_regreso     || "",
        codigo_reserva:       viajeInicial.codigo_reserva         || "",
      }
    }
    return { ...VIAJE_VACIO, origen: clienteOrigen || "", codigo_reserva: "" }
  })

  const [guardando, setGuardando]               = useState(false)
  const [exito, setExito]                       = useState(false)
  const [confirmarEliminar, setConfirmarEliminar] = useState(false)
  const [eliminando, setEliminando]             = useState(false)

  const [d1Modo, setD1Modo] = useState(() => {
    const v = viajeInicial ? (viajeInicial.destino1 || viajeInicial.destino || "") : ""
    return !v || DESTINOS_VIAJE.includes(v) ? "lista" : "libre"
  })
  const [d1Libre, setD1Libre] = useState(() => {
    const v = viajeInicial ? (viajeInicial.destino1 || viajeInicial.destino || "") : ""
    return v && !DESTINOS_VIAJE.includes(v) ? v : ""
  })
  const [d2Modo, setD2Modo] = useState(() => {
    const v = viajeInicial ? (viajeInicial.destino2 || "") : ""
    return !v || DESTINOS_VIAJE.includes(v) ? "lista" : "libre"
  })
  const [d2Libre, setD2Libre] = useState(() => {
    const v = viajeInicial ? (viajeInicial.destino2 || "") : ""
    return v && !DESTINOS_VIAJE.includes(v) ? v : ""
  })

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }))
  const sel = { ...INPUT_S, cursor:"pointer" }

  // ── Auto-cálculo bidireccional ─────────────────
  function handleFechaSalida(val) {
    setForm(p => {
      const n = { ...p, fecha_salida: val }
      if (val && p.fecha_regreso) {
        const diff = Math.round((new Date(p.fecha_regreso) - new Date(val)) / 86400000)
        if (diff > 0) n.noches = String(diff)
      } else if (val && p.noches && Number(p.noches) > 0) {
        const d = new Date(val); d.setDate(d.getDate() + Number(p.noches))
        n.fecha_regreso = d.toISOString().split("T")[0]
      }
      return n
    })
  }

  function handleFechaRegreso(val) {
    setForm(p => {
      const n = { ...p, fecha_regreso: val }
      if (p.fecha_salida && val) {
        const diff = Math.round((new Date(val) - new Date(p.fecha_salida)) / 86400000)
        if (diff > 0) n.noches = String(diff)
      }
      return n
    })
  }

  function handleNoches(val) {
    setForm(p => {
      const n = { ...p, noches: val }
      if (p.fecha_salida && val && Number(val) > 0) {
        const d = new Date(p.fecha_salida); d.setDate(d.getDate() + Number(val))
        n.fecha_regreso = d.toISOString().split("T")[0]
      }
      return n
    })
  }

  async function handleGuardar() {
    if (!form.destino1 || !form.fecha_salida) return
    setGuardando(true)
    try {
      const datos = {
        ...form,
        destino: form.destino1 + (form.destino2 ? " + " + form.destino2 : ""),
        noches:Number(form.noches)||0,
        pax:Number(form.pax)||0,
        monto_venta:Number(form.monto_venta)||0
      }
      if (esNuevo) {
        const ref = await addDoc(collection(db,"usuarios_sheets",clienteId,"viajes"), { ...datos, creado_en:new Date() })
        onGuardado({ id:ref.id, cliente_id:clienteId, ...datos }, true)
        const monto = parseFloat(form.monto_venta)
        if (!isNaN(monto) && monto > 0) {
          const puntosNuevos = Math.round(monto * 0.1)
          const clienteRef = doc(db, "usuarios_sheets", clienteId)
          const clienteSnap = await getDoc(clienteRef)
          if (clienteSnap.exists()) {
            const puntosActuales = clienteSnap.data().puntos_aporte || 0
            await updateDoc(clienteRef, { puntos_aporte: puntosActuales + puntosNuevos })
          }
        }
      } else {
        await updateDoc(doc(db,"usuarios_sheets",clienteId,"viajes",viajeInicial.id), { ...datos, actualizado_en:new Date() })
        onGuardado({ ...viajeInicial, ...datos }, false)
      }
      setExito(true); setTimeout(onCerrar, 800)
    } catch(e) { console.error(e) } finally { setGuardando(false) }
  }

  async function handleEliminar() {
    setEliminando(true)
    try {
      await deleteDoc(doc(db,"usuarios_sheets",clienteId,"viajes",viajeInicial.id))
      onGuardado({ ...viajeInicial, _eliminado:true }, false); onCerrar()
    } catch(e) { console.error(e) } finally { setEliminando(false) }
  }

  const saldo = Math.max(0,(parseFloat(form.monto_venta)||0)-(parseFloat(form.monto_reserva)||0))
    const textoAdmin = [
      `VENTA NUEVA – LOW TRAVEL`,
      ``,
      `DATOS DEL TITULAR`,
      `Nombre y apellido: ${clienteNombre}`,
      `CUIL/CUIT: ${clienteCuil||"_________________________"}`,
      ``,
      `DATOS DE CONTACTO`,
      `Tel: ${clienteTelefono||"_________________________"}`,
      `Mail: ${clienteEmail||"_________________________"}`,
      ``,
      `PASAJEROS`,
      `Cantidad: ${form.pax}`,
      ``,
      `DETALLE DEL VIAJE`,
      `Destino: ${form.destino1+(form.destino2?" / "+form.destino2:"")}`,
      `Fecha de ida: ${form.fecha_salida||"—"}`,
      `Fecha de regreso: ${form.fecha_regreso||"—"}`,
      ``,
      `Servicios incluidos:`,
      `- Vuelo: ${form.aerolinea?"Si":"No"}`,
      `- Hospedaje: ${form.hotel1?"Si":"No"}`,
      `- Traslados: ${form.traslados?`Si (${form.traslados})`:"No"}`,
      `- Asistencia: ${form.asistencia}`,
      ``,
      `PRECIO DE VENTA`,
      `Precio de venta: ${form.monto_venta||0} USD`,
      `Monto abonado: ${form.monto_reserva||0} USD`,
      `Saldo pendiente: ${saldo} USD`,
      `Plan de pago: _________________________`,
      ``,
      `OBSERVACIONES`,
      `_________________________`,
    ].join("\n")
  return (
    <Modal titulo={esNuevo?"Nueva venta":"Editar viaje"} subtitulo={clienteNombre} onCerrar={onCerrar} ancho="680px">
      {exito ? (
        <div style={{ textAlign:"center", padding:"30px" }}>
          <div style={{ fontSize:"2rem", marginBottom:"8px" }}>✓</div>
          <div style={{ color:"#10b981", fontWeight:800 }}>{esNuevo?"Venta registrada":"Guardado"}</div>
        </div>
      ) : confirmarEliminar ? (
        <div>
          <div style={{ background:"#2a0a0a", border:"1px solid #ef444440", borderRadius:"10px", padding:"16px", marginBottom:"20px" }}>
            <div style={{ fontWeight:700, color:"#ef4444", marginBottom:"6px" }}>⚠️ Eliminar viaje</div>
            <div style={{ fontSize:"0.875rem", color:"#9ca3af" }}>Se eliminará el viaje a <strong style={{ color:"#e5e7eb" }}>{viajeInicial?.destino}</strong>. Irreversible.</div>
          </div>
          <div style={{ display:"flex", gap:"8px" }}>
            <button onClick={()=>setConfirmarEliminar(false)} style={{ ...BTN_GHOST, flex:1 }}>Cancelar</button>
            <button onClick={handleEliminar} disabled={eliminando} style={{ flex:1, padding:"10px", background:"#ef4444", border:"none", borderRadius:"8px", color:"white", fontFamily:"Inter, sans-serif", fontWeight:700, cursor:"pointer" }}>{eliminando?"Eliminando...":"Confirmar"}</button>
          </div>
        </div>
      ) : (
        <div>
          {/* ── Sección principal ── */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px", marginBottom:"12px" }}>

            <div style={{ gridColumn:"1/-1", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>
              <div>
                <label style={LABEL_S}>Destino 1 *</label>
                <select
                  value={d1Modo === "libre" ? OTRO : form.destino1}
                  onChange={e => {
                    if (e.target.value === OTRO) {
                      setD1Modo("libre")
                      set("destino1", d1Libre)
                    } else {
                      setD1Modo("lista")
                      set("destino1", e.target.value)
                    }
                  }}
                  style={{ ...INPUT_S, cursor:"pointer" }}
                >
                  <option value="">Seleccionar...</option>
                  {DESTINOS_VIAJE.map(d => <option key={d}>{d}</option>)}
                  <option value={OTRO}>✏️ Otro destino...</option>
                </select>
                {d1Modo === "libre" && (
                  <input
                    value={d1Libre}
                    onChange={e => { setD1Libre(e.target.value); set("destino1", e.target.value) }}
                    style={{ ...INPUT_S, marginTop:"6px" }}
                    placeholder="Ej: Natal, Porto Seguro..."
                    autoFocus
                  />
                )}
              </div>
            <div>
              <label style={LABEL_S}>Destino 2</label>
              <select
                value={d2Modo === "libre" ? OTRO : form.destino2}
                onChange={e => {
                  if (e.target.value === OTRO) {
                    setD2Modo("libre")
                    set("destino2", d2Libre)
                  } else {
                    setD2Modo("lista")
                    set("destino2", e.target.value)
                  }
                }}
                style={{ ...INPUT_S, cursor:"pointer" }}
              >
                <option value="">Ninguno</option>
                {DESTINOS_VIAJE.filter(d => d !== form.destino1).map(d => <option key={d}>{d}</option>)}
                <option value={OTRO}>✏️ Otro destino...</option>
              </select>
              {d2Modo === "libre" && (
                <input
                  value={d2Libre}
                  onChange={e => { setD2Libre(e.target.value); set("destino2", e.target.value) }}
                  style={{ ...INPUT_S, marginTop:"6px" }}
                  placeholder="Ej: Natal, Porto Seguro..."
                />
              )}
            </div>
          </div>

            {/* Fechas con autocálculo */}
            <div>
              <label style={LABEL_S}>Fecha de salida *</label>
              <input type="date" value={form.fecha_salida} onChange={e=>handleFechaSalida(e.target.value)} style={INPUT_S}/>
            </div>
            <div>
              <label style={LABEL_S}>
                Fecha de regreso
                {form.fecha_salida && form.fecha_regreso && <span style={{ color:"#10b981", fontWeight:400, marginLeft:"6px", fontSize:"0.7rem" }}>✓ calculada</span>}
              </label>
              <input type="date" value={form.fecha_regreso} onChange={e=>handleFechaRegreso(e.target.value)} style={INPUT_S}/>
            </div>

            <div>
              <label style={LABEL_S}>
                Noches
                {form.fecha_salida && form.fecha_regreso && <span style={{ color:"#10b981", fontWeight:400, marginLeft:"6px", fontSize:"0.7rem" }}>✓ auto</span>}
              </label>
              <input type="number" min="1" value={form.noches} onChange={e=>handleNoches(e.target.value)} style={INPUT_S} placeholder="7"/>
            </div>
            <div>
              <label style={LABEL_S}>Pax</label>
              <input type="number" min="1" value={form.pax} onChange={e=>set("pax",e.target.value)} style={INPUT_S} placeholder="2"/>
            </div>

            {/* Vuelo de ida */}
            <div style={{ gridColumn:"1/-1", borderTop:"1px solid #2a2a2a", paddingTop:"10px", marginTop:"2px" }}>
              <div style={{ fontSize:"0.75rem", fontWeight:700, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"10px" }}>Vuelo de ida</div>
              <div>
                <label style={LABEL_S}>Hora de salida</label>
                <input type="time" value={form.hora_vuelo_salida} onChange={e=>set("hora_vuelo_salida",e.target.value)} style={INPUT_S}/>
              </div>
            </div>

            {/* Vuelo de regreso */}
            <div style={{ gridColumn:"1/-1" }}>
              <div style={{ fontSize:"0.75rem", fontWeight:700, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"10px" }}>Vuelo de regreso</div>
              <div>
                <label style={LABEL_S}>Hora de regreso</label>
                <input type="time" value={form.hora_vuelo_regreso} onChange={e=>set("hora_vuelo_regreso",e.target.value)} style={INPUT_S}/>
              </div>
            </div>

            <div>
              <label style={LABEL_S}>Aerolínea</label>
              <select value={form.aerolinea} onChange={e=>set("aerolinea",e.target.value)} style={sel}>
                <option value="">Seleccionar</option>
                {AEROLINEAS.map(a=><option key={a}>{a}</option>)}
              </select>
            </div>
            <div>
              <label style={LABEL_S}>Código de reserva</label>
              <input value={form.codigo_reserva} onChange={e=>set("codigo_reserva",e.target.value)} style={INPUT_S} placeholder="Ej: AMPMWP"/>
            </div>

            {/* Estado solo visible al editar */}
            {!esNuevo && (
              <div>
                <label style={LABEL_S}>Estado</label>
                <select value={form.estado} onChange={e=>set("estado",e.target.value)} style={sel}>
                  {["confirmado","en_curso","completado","cancelado"].map(s=>(
                    <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>
                  ))}
                </select>
              </div>
            )}

            <div>
              <label style={LABEL_S}>Hotel 1</label>
              <input value={form.hotel1} onChange={e=>set("hotel1",e.target.value)} style={INPUT_S} placeholder="Nombre del hotel"/>
            </div>
            <div>
              <label style={LABEL_S}>Hotel 2</label>
              <input value={form.hotel2} onChange={e=>set("hotel2",e.target.value)} style={INPUT_S} placeholder="Opcional"/>
            </div>

            <div style={{ gridColumn:"1/-1" }}>
              <label style={LABEL_S}>Incluye</label>
              <input value={form.incluye} onChange={e=>set("incluye",e.target.value)} style={INPUT_S} placeholder="Desayuno, traslados..."/>
            </div>

            <div>
              <label style={LABEL_S}>Asistencia al viajero</label>
              <select value={form.asistencia} onChange={e=>set("asistencia",e.target.value)} style={sel}>
                <option>Si</option><option>No</option>
              </select>
            </div>
          </div>

          {/* ── Datos internos ── */}
          <div style={{ borderTop:"1px solid #2a2a2a", paddingTop:"12px", marginBottom:"12px" }}>
            <div style={{ fontSize:"0.75rem", fontWeight:700, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"10px" }}>Datos internos</div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px" }}>

              <div>
                <label style={LABEL_S}>Canal de venta</label>
                <select value={form.canal_venta} onChange={e=>set("canal_venta",e.target.value)} style={sel}>
                  <option value="">Seleccionar</option>
                  {CANALES.map(c=><option key={c}>{c}</option>)}
                </select>
              </div>

              <div>
                <label style={LABEL_S}>
                  Origen
                  {clienteOrigen && <span style={{ color:"#6b7280", fontWeight:400, marginLeft:"6px", fontSize:"0.7rem" }}>del cliente</span>}
                </label>
                <select value={form.origen} onChange={e=>set("origen",e.target.value)} style={sel}>
                  <option value="">Seleccionar</option>
                  {PROVINCIAS.map(p=><option key={p}>{p}</option>)}
                </select>
              </div>

              {form.canal_venta === "Referidos" && (
                <div style={{ gridColumn:"1/-1" }}>
                  <label style={LABEL_S}>Referido por (buscar cliente)</label>
                  <BuscadorReferido
                    clientes={clientes||[]}
                    clienteId={clienteId}
                    value={form.referido_por}
                    onSelect={c => {
                      if (c) set("referido_por", `${c.nombre} ${c.apellido}`)
                      else set("referido_por", "")
                    }}
                  />
                </div>
              )}

              <div>
              <label style={LABEL_S}>Traslados</label>
              <select value={form.traslados} onChange={e=>set("traslados",e.target.value)} style={{ ...INPUT_S, cursor:"pointer" }}>
                <option value="">No incluido</option>
                <option value="Regular">Regular</option>
                <option value="Privado">Privado</option>
              </select>
            </div>

            <div>
              <label style={LABEL_S}>Monto de venta (USD)</label>
              <input type="number" min="0" value={form.monto_venta} onChange={e=>set("monto_venta",e.target.value)} style={INPUT_S} placeholder="0"/>
            </div>

            <div>
              <label style={LABEL_S}>Monto reserva (USD)</label>
              <input type="number" min="0" value={form.monto_reserva} onChange={e=>set("monto_reserva",e.target.value)} style={INPUT_S} placeholder="0"/>
            </div>

            <div>
              <label style={LABEL_S}>Saldo pendiente (USD)</label>
              <div style={{ ...INPUT_S, background:"#111", color: (parseFloat(form.monto_venta)||0)-(parseFloat(form.monto_reserva)||0) > 0 ? "#f97316" : "#6b7280", fontWeight:700 }}>
                {form.monto_venta || form.monto_reserva
                  ? `${Math.max(0,(parseFloat(form.monto_venta)||0)-(parseFloat(form.monto_reserva)||0)).toLocaleString("es-AR")} USD`
                  : "—"
                }
              </div>
            </div>
            </div>
          </div>

          <button
            onClick={handleGuardar}
            disabled={guardando || !form.destino1 || !form.fecha_salida}
            style={{ width:"100%", ...BTN_PRIMARY, background:(!form.destino1||!form.fecha_salida||guardando)?"#1a1a1a":"#3b82f6", color:(!form.destino1||!form.fecha_salida||guardando)?"#4b5563":"white" }}
          >
            {guardando ? "Guardando..." : (esNuevo ? "Registrar venta" : "Guardar cambios")}
          </button>

          {esNuevo && (
            <div style={{ marginTop:"16px", borderTop:"1px solid #2a2a2a", paddingTop:"14px" }}>
              <div style={{ fontSize:"0.75rem", fontWeight:700, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"10px" }}>
                📋 Texto para administración
              </div>
              <div style={{ background:"#1a1a1a", borderRadius:"8px", padding:"14px", fontSize:"0.8rem", color:"#9ca3af", lineHeight:1.8, fontFamily:"monospace", whiteSpace:"pre-wrap" }}>
                {textoAdmin}
              </div>
              <button
                onClick={() => navigator.clipboard.writeText(textoAdmin)}
                style={{ marginTop:"8px", padding:"7px 16px", background:"#25d366", border:"none", borderRadius:"6px", color:"white", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor:"pointer" }}
              >
                Copiar texto
              </button>
            </div>
          )}

          {!esNuevo && (
            <div style={{ borderTop:"1px solid #2a2a2a", paddingTop:"12px", marginTop:"12px" }}>
              <button onClick={()=>setConfirmarEliminar(true)} style={{ background:"none", border:"none", color:"#4b5563", fontFamily:"Inter, sans-serif", fontSize:"0.8rem", cursor:"pointer", textDecoration:"underline" }}>
                Eliminar este viaje
              </button>
            </div>
          )}
        </div>
      )}
    </Modal>
  )
}
